export const FOOTER_HEIGHT = 300
export const MOBILE_HEADER_HEIGHT = 79
export const WEB_HEADER_HEIGHT = 79
